import Vue from 'vue'
import { floatHorizontal } from './directives'

Vue.directive(floatHorizontal.name, floatHorizontal)
